<template>
  <AdminLayout>
    <Head title="Delivery" />
    <DeliveryTable />
  </AdminLayout>
</template>

<script setup>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head } from '@inertiajs/vue3'
import DeliveryTable from '@/Components/DataGrid/Tables/Deliveries.vue'
import { router } from '@inertiajs/vue3'
import { useScanner, SCAN_PREFIX } from '@/Composables/scanner'
import { useInitGridState } from '@/Components/DataGrid/Composables/grid-state'

useInitGridState()

const scanner = useScanner()

scanner.addListener((identifier, prefix) => {
  if (prefix === SCAN_PREFIX.ORDER) {
    scanner.buffer.start()
    router.visit(route('deliveries.show', identifier))
  }
})
</script>
